import { useState, useCallback } from 'react';

/**
 * useGridPageSize — quản lý pageSize cho 1 grid, persist localStorage theo page-key.
 *
 * Mỗi page (Roles/Users/Policies/...) có key riêng → user đổi pageSize ở Roles
 * không ảnh hưởng Users. Phiên sau load lại pageSize đã chọn.
 *
 * Usage:
 *   const [pageSize, setPageSize] = useGridPageSize('roles', 25);
 *   <Table pagination={{
 *     pageSize,
 *     showSizeChanger: true,
 *     pageSizeOptions: ['10','25','50','100','200'],
 *     onShowSizeChange: (_, size) => setPageSize(size),
 *   }} />
 */
const STORAGE_PREFIX = 'zero.grid.pageSize.';
const VALID_SIZES = [10, 25, 50, 100, 200];

export function useGridPageSize(pageKey, defaultSize = 25) {
  const storageKey = STORAGE_PREFIX + pageKey;

  const [pageSize, setPageSizeState] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      const n = raw ? parseInt(raw, 10) : NaN;
      return VALID_SIZES.includes(n) ? n : defaultSize;
    } catch {
      return defaultSize;
    }
  });

  const setPageSize = useCallback((size) => {
    const valid = VALID_SIZES.includes(size) ? size : defaultSize;
    setPageSizeState(valid);
    try { localStorage.setItem(storageKey, String(valid)); } catch { /* ignore */ }
  }, [storageKey, defaultSize]);

  return [pageSize, setPageSize];
}

export const GRID_PAGE_SIZE_OPTIONS = ['10', '25', '50', '100', '200'];
